


















import {Component, Prop, Vue ,Watch} from "vue-property-decorator";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
@Component({
    components:{
        EnabledSwitch
    }
})
export default class CategoriesSelect extends Vue {
    @Prop({}) value!:string;
    @Prop({}) label!:string;
    @Prop({default:"12"}) md!:string;
    @Prop({}) items!:any;
    @Prop({default:true}) required!:boolean;
    @Prop({}) slice!:number | null;
    @Prop({default:false}) switchEnabled!:boolean;
    @Watch("slice")
    @Watch("value")
    onPropertyChanged(value: string, oldValue: string) {
        this.get();
    }
    data:any=[];
    enabled:any=0;
    updateValue (value:string) {
        this.$emit('input', value)
    }
    async created(){
        this.get();
    }
    async get(){
        //console.log(this.value);
        if(this.items != null){
            this.data = this.items;
        }else{
            let categories = await this.$http.get("categories");
            this.data = categories.data;
        }
        if(this.slice != null){
            this.data = this.data.filter((item : any) =>item.cat_id != this.slice);
        }
    }
}
